import { JobNoteList } from './JobNoteList';

interface NotesProps {
  jobId: number;
  hideSummary?: boolean;
  showExport?: boolean;
}

export const Notes = ({ jobId, hideSummary = false, showExport = false }: NotesProps) => {
  return (
    <div className="relative mx-auto flex w-full max-w-[1200px] flex-col bg-white px-2 pt-6 sm:px-6">
      <JobNoteList jobId={jobId} hideSummary={hideSummary} showExport={showExport} />
    </div>
  );
};
